var ID = 'ApplePaySDK';
var SCRIPT_SRC = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
export var loadApplePaySdk = function () {
    if (window.ApplePaySession || document.getElementById(ID)) {
        return Promise.resolve();
    }
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.id = ID;
        script.crossOrigin = 'anonymous';
        script.onload = function () { return resolve(); };
        script.onerror = function () { return reject(new Error('Failed to load Apple Pay SDK')); };
        script.src = SCRIPT_SRC;
        document.body.appendChild(script);
    });
};
